import FluentUiIcon from "../../../../../../assets/fluent-ui-icon";
import { NIL as NIL_UUID, v4 as uuidv4 } from "uuid";

export const validationMessages = {
  formNameEmpty: "Form name cannot be empty. Please enter a valid form name.",
  formNameDuplicate:
    "This name has been used by another Form in the Task Type. Please enter a different name.",
  sectionNameEmpty: "Section name cannot be empty. Please enter a valid section name.",
  sectionNameDuplicate:
    "This name has been used by another Section in this Form. Please enter a different name.",
};

export const radioOptions = [
  { value: false, label: "Editable" },
  { value: true, label: "Read-only" },
];

export const contextMenuItems = [
  {
    Text: "Edit",
    Icon: <FluentUiIcon name={"OpenBundle"} color={"#212121"} size={20} />,
    onClick: null,
  },
  {
    Text: "Rename",
    Icon: <FluentUiIcon name={"RenameBundle"} color={"#212121"} size={20} />,
    onClick: null,
  },
  {
    Text: "Delete",
    Icon: <FluentUiIcon name={"DeleteBundle"} color={"#212121"} size={20} />,
    onClick: null,
  }, 
];

export const ParseContextMenuItems = (listener) => {
  return contextMenuItems.map((item) => {
    return {
      ...item,
      onClick: (e) => listener(e, item.Text),
    };
  });
};

export const GetIconForField = (fieldType) => {
  switch (fieldType) {
    case "Short Text Entry":
      return "TextCaseTitleRegular";
    case "Long Text Entry":
      return "TextDescriptionRegular";
    case "Date":
      return "CalendarRegular";
    case "Time Duration":
      return "HourglassHalfRegular";
    case "Numeric (Integer)":
      return "NumberSymbolRegular";
    case "Numeric (Decimal)":
      return "NumberSymbolFilled";
    case "Toggle":
      return "ToggleLeftRegular";
    case "Checkbox":
      return "CheckboxCheckedRegular";
    case "Radio Buttons":
      return "RadioButtonFilled";
    case "Dropdown":
      return "ChevronCircleDownRegular";
    case "Dependant Dropdown":
      return "ChevronDoubleDownRegular";
    case "URL":
      return "LinkRegular";
    case "File":
      return "DocumentRegular";
    case "Table":
      return "TableRegular";
    default:
      return "TextCaseTitleRegular";
  }
};

export const ParseAddToSectionItems = (listener, items, field) => {
  return items?.map((item) => {
    return {
      Text: item.split(":")[1],
      disabled : field.FieldType === "Table" && item.split(":")[1] === "Comment Fields",
      onClick: (e) =>
        listener(e, parseInt(item.split(":")[0]), item.split(":")[1]),
    };
  });
};

export const AddFieldToSectionUtil = (
  allForms,
  currentFormDisplayOrder,
  subFormDisplayOrder,
  field
) => {
  const newAllForms = JSON.parse(JSON.stringify(allForms));
  const newCurrentForm = newAllForms.find(
    (f) => f.DisplayOrder === currentFormDisplayOrder
  );
  const newField = JSON.parse(JSON.stringify(field));
  const subForm = newCurrentForm.SubForms.find(
    (sf) => sf.DisplayOrder === subFormDisplayOrder
  );

  let newFieldDisplayOrder =
    subForm.Fields.length === 0
      ? 1
      : subForm.Fields[subForm.Fields.length - 1].DisplayOrder + 1;

  subForm.Fields.push({
    ...newField,
    LocalLabel: newField.Label,
    IsRequired: newField.Required,
    IsDisabled: false,
    LookupValues: "",
    DisplayOrder: newFieldDisplayOrder,
    DynamicFieldId: newField.Id,
    Id: NIL_UUID,
  });
  return newAllForms;
};

export const generateUniqueSectionName = (existingSections) => {
  const baseName = "Untitled Section";
  const existingLabels = new Set((existingSections || []).map((s) => s.Label));

  if (!existingLabels.has(baseName)) return baseName;

  let counter = 1;
  while (existingLabels.has(`${baseName} ${counter}`)) {
    counter++;
  }
  return `${baseName} ${counter}`;
};

export const AddSectionUtil = (allForms, currentFormDisplayOrder) => {
  const newAllForms = JSON.parse(JSON.stringify(allForms));
  const newCurrentForm = newAllForms.find(
    (f) => f.DisplayOrder === currentFormDisplayOrder
  );

  let newSectionDisplayOrder =
    newCurrentForm.SubForms.length === 0
      ? 1
      : newCurrentForm.SubForms[newCurrentForm.SubForms.length - 1]
          .DisplayOrder + 1;

  newCurrentForm.SubForms.push({
    Id: NIL_UUID,
    Label: generateUniqueSectionName(newCurrentForm.SubForms),
    DisplayOrder: newSectionDisplayOrder,
    Fields: [],
  });

  return newAllForms;
};

export const RenameSectionUtil = (
  allForms,
  currentFormDisplayOrder,
  subFormDisplayOrder,
  label
) => {
  const newAllForms = JSON.parse(JSON.stringify(allForms));
  const newCurrentForm = newAllForms.find(
    (f) => f.DisplayOrder === currentFormDisplayOrder
  );
  const subForm = newCurrentForm.SubForms.find(
    (sf) => sf.DisplayOrder === subFormDisplayOrder
  );
  subForm.Label = label;

  return newAllForms;
};

export const DeleteSectionUtil = (
  allForms,
  currentFormDisplayOrder,
  subFormDisplayOrder
) => {
  const newAllForms = JSON.parse(JSON.stringify(allForms));
  const newCurrentForm = newAllForms.find(
    (f) => f.DisplayOrder === currentFormDisplayOrder
  );
  let newSubFormId = newCurrentForm.SubForms.find(
    (sf) => sf.DisplayOrder === subFormDisplayOrder
  )?.Id;
  newCurrentForm.SubForms = newCurrentForm.SubForms.filter(
    (sf) => sf.DisplayOrder !== subFormDisplayOrder
  );

  return { newAllForms, newSubFormId };
};

export const RenameFormUtil = (allForms, formDisplayOrder, label) => {
  const newForms = JSON.parse(JSON.stringify(allForms));
  const form = newForms.find((sf) => sf.DisplayOrder === formDisplayOrder);

  form.Label = label;

  return newForms;
};

export const DeleteFormUtil = (allForms, formDisplayOrder) => {
  let newForms = JSON.parse(JSON.stringify(allForms));
  let newFormId = newForms.find(
    (sf) => sf.DisplayOrder === formDisplayOrder
  )?.Id;
  newForms = newForms.filter((sf) => sf.DisplayOrder !== formDisplayOrder);

  return { newForms, newFormId };
};

export const generateUniqueFormName = (existingForms) => {
  const baseName = "Untitled Form";
  const existingLabels = new Set((existingForms || []).map((f) => f.Label));

  if (!existingLabels.has(baseName)) return baseName;

  let counter = 1;
  while (existingLabels.has(`${baseName} ${counter}`)) {
    counter++;
  }
  return `${baseName} ${counter}`;
};

export const AddFormUtil = (allForms) => {
  if (!allForms) allForms = [];
  const newForms = JSON.parse(JSON.stringify(allForms));

  let newFormDisplayOrder =
    newForms.length === 0 ? 1 : newForms[newForms.length - 1].DisplayOrder + 1;

  newForms.push({
    Id: NIL_UUID,
    Label: generateUniqueFormName(newForms),
    DisplayOrder: newFormDisplayOrder,
    SubForms: [],
  });

  return { newForms, newFormDisplayOrder };
};


export const ModifyFromFieldUtil = (
  allForms,
  currentFormDisplayOrder,
  currentSubFormDisplayOrder,
  field,
  direction
) => {
  const newAllForms = JSON.parse(JSON.stringify(allForms));
  const newCurrentForm = newAllForms.find(
    (f) => f.DisplayOrder === currentFormDisplayOrder
  );
  const newCurrentSubForm = newCurrentForm.SubForms.find(
    (f) => f.DisplayOrder === currentSubFormDisplayOrder
  );
  let newCurrentSubFormField = newCurrentSubForm.Fields.find(
    (f) => f.DisplayOrder === field.DisplayOrder
  );

  newCurrentSubFormField.LocalLabel = field.LocalLabel;
  newCurrentSubFormField.IsRequired = field.IsRequired;
  newCurrentSubFormField.IsDisabled = field.IsDisabled;

  try
  {
    if(direction === "up") {
      //Animation For row swapping, Id's are unique by appending FieldId + Column ID
      let a = document.getElementById(`animate-`+ newCurrentSubForm.DisplayOrder +`-`+(newCurrentSubFormField.DisplayOrder-1));
      let b = document.getElementById(`animate-`+ newCurrentSubForm.DisplayOrder +`-`+newCurrentSubFormField.DisplayOrder);
      //remove existing classes
      a.classList.remove("moveUp");
      a.classList.remove("moveDown");
      b.classList.remove("moveUp");
      b.classList.remove("moveDown");
      //trigger reflow
      void a.offsetWidth;
      void b.offsetWidth;
      //add animation
      a.classList.add("moveUp");
      b.classList.add("moveDown");
      let secondField = newCurrentSubForm.Fields.find(
        (f) => f.DisplayOrder === field.DisplayOrder - 1
      );
      secondField.DisplayOrder += 1;
      newCurrentSubFormField.DisplayOrder -=1;
      newCurrentSubForm.Fields.sort((a, b) => a.DisplayOrder - b.DisplayOrder);
    }
    else if(direction === "down") {
      let a = document.getElementById(`animate-`+ newCurrentSubForm.DisplayOrder +`-`+ newCurrentSubFormField.DisplayOrder);
      let b = document.getElementById(`animate-`+ newCurrentSubForm.DisplayOrder +`-`+(newCurrentSubFormField.DisplayOrder+1));
      a.classList.remove("moveUp");
      a.classList.remove("moveDown");
      b.classList.remove("moveUp");
      b.classList.remove("moveDown");
      //trigger reflow
      void a.offsetWidth;
      void b.offsetWidth;
      //add animation
      a.classList.add("moveUp");
      b.classList.add("moveDown");
      let secondField = newCurrentSubForm.Fields.find(
        (f) => f.DisplayOrder === field.DisplayOrder + 1
      );
      secondField.DisplayOrder -= 1;
      newCurrentSubFormField.DisplayOrder +=1;
      newCurrentSubForm.Fields.sort((a, b) => a.DisplayOrder - b.DisplayOrder);
    }
  }
  catch
  {
    console.log("Error in Ordering Animation");
  }
  return newAllForms;
};

export const DeleteFormFieldUtil = (
  allForms,
  currentFormDisplayOrder,
  currentSubFormDisplayOrder,
  field
) => {
  const newAllForms = JSON.parse(JSON.stringify(allForms));
  const newCurrentForm = newAllForms.find(
    (f) => f.DisplayOrder === currentFormDisplayOrder
  );
  const newCurrentSubForm = newCurrentForm.SubForms.find(
    (f) => f.DisplayOrder === currentSubFormDisplayOrder
  );
  let newCurrentSubFormField = newCurrentSubForm.Fields.find(
    (f) => f.DisplayOrder === field.DisplayOrder
  );
  newCurrentSubForm.Fields = newCurrentSubForm.Fields.filter(
    (sf) => sf.DisplayOrder !== field.DisplayOrder
  );
  newCurrentSubForm.Fields.forEach(f => {
    if (f.DisplayOrder > field.DisplayOrder) {
      f.DisplayOrder -= 1;
    }
  });

  let newFieldId = newCurrentSubFormField.Id;

  return { newAllForms, newFieldId };
};

export const LabelBlurUtil = (allFormNames, formDisplayOrder, label) => {
  let filteredFormNames = allFormNames
    .filter((f) => f.DisplayOrder !== formDisplayOrder)
    .map((f) => f.Label);
  let message;

  if (label.trim() === "") {
    message = validationMessages.formNameEmpty;
  } else if (filteredFormNames.includes(label.trim())) {
    message = validationMessages.formNameDuplicate;
  } else {
    message = "";
  }

  return { message, formName: label.trim() };
};

export const SectionLabelBlurUtil = (allSections, sectionDisplayOrder, label) => {
  let filteredSectionNames = allSections
    .filter((s) => s.DisplayOrder !== sectionDisplayOrder)
    .map((s) => s.Label);
  let message;

  if (label.trim() === "") {
    message = validationMessages.sectionNameEmpty;
  } else if (filteredSectionNames.includes(label.trim())) {
    message = validationMessages.sectionNameDuplicate;
  } else {
    message = "";
  }

  return { message, sectionName: label.trim() };
};

export const RemoveEmptyIds = (list, id) => {
  if (id === NIL_UUID) return list;
  return [...list, id];
};

export const byOrder = (a, b) => (a.DisplayOrder ?? 0) - (b.DisplayOrder ?? 0);

export const isParent = (f) => f.DynamicFieldId === 0 && f.SubSectionId == null;

export const buildUnits = (ordered) => {
  const units = [];
  let i = 0;
  while (i < ordered.length) {
    const row = ordered[i];
    if (!isParent(row)) {
      units.push([row]);
      i += 1;
      continue;
    }
    const unit = [row];
    let j = i + 1;
    while (j < ordered.length && ordered[j].SubSectionId === row.Id) {
      unit.push(ordered[j]);
      j += 1;
    }
    units.push(unit);
    i = j;
  }
  return units;
};

export const flattenUnits = (units) => units.flat();

export const buildDisplayMap = (ordered = []) => {
  const map = {};
  const units = buildUnits(ordered);

  for (let u = 0; u < units.length; u++) {
    const unit = units[u];
    const unitIndex = u + 1;

    const parent = unit[0];
    map[getRowKey(parent)] = unitIndex;

    for (let c = 1; c < unit.length; c++) {
      const child = unit[c];
      map[getRowKey(child)] = `${unitIndex}.${c}`;
    }
  }

  return map;
};

export const newGuid = () => uuidv4();

export const isZeroGuid = (id) => !id || id === NIL_UUID;

export const getRowKey = (row) => {
  if (row?.Id && !isZeroGuid(row.Id)) return row.Id;
  return `df:${row?.DynamicFieldId ?? "nil"}|sf:${row?.SubFormId ?? "nil"}|f:${row?.FormId ?? "nil"}`;
};

export const rowsEqual = (a, b) => {
  const aHasId = a?.Id && !isZeroGuid(a.Id);
  const bHasId = b?.Id && !isZeroGuid(b.Id);
  if (aHasId && bHasId) return a.Id === b.Id;
  return (a?.DynamicFieldId ?? null) === (b?.DynamicFieldId ?? null);
};

export const rowMatchesRef = (row, { Id, DynamicFieldId }) => {
  const rowHasId = row?.Id && !isZeroGuid(row.Id);
  const refHasId = Id && !isZeroGuid(Id);
  if (rowHasId && refHasId) return row.Id === Id;
  return (row?.DynamicFieldId ?? null) === (DynamicFieldId ?? null);
};

export const newSectionObject = (currentForm, subForm) => ({
  Id: newGuid(),
  CompanyId: currentForm.CompanyId ?? null,
  FormId: currentForm.Id,
  SubFormId: subForm.Id,
  DynamicFieldId: 0,
  DisplayOrder: 1,
  FieldHelp: null,
  IsRequired: false,
  IsDisabled: false,
  DefaultValue: null,
  LocalLabel: "",
  DefaultLabel: "",
  IsBaseField: false,
  IsHidden: false,
  IsDataGrid: false,
  IsVisible: true,
  APIName: null,
  Description: "",
  Files: [],
  LookUpValues: null,
  Table: null,
  Data: null,
  DataId: 0,
  SubSectionId: null
});